class ValidateVolumeError extends Error {
  constructor(msg) {
    super(msg);
    this.name = 'ValidateVolumeError';
  }
}

export default ValidateVolumeError;
